import React from 'react';
import moment from 'moment';

import { ClockIcon } from './icons/clock-icon';
import { GroupIcon } from './icons/group-icon';
import { renderPlayersCount } from '../renders';
import { renderMoney } from 'components/table/renders';
import { DailyDealIcon } from './icons/daily-deal-icon';
import { PathCreator, RoutePaths } from 'routing/constants';
import { ServerTimeFormat, TimeFormat } from 'utils/constants';

import {
  DailyDealItem,
  DailyDealPrice,
  DailyDealTitle,
  DailyDealWrapper,
  DailyDealDetails,
  DailyDealLogoWrapper,
} from './elements';

import type { IRate } from 'modules/api-requests/rates/types';
import type { ITableTeeTime } from 'modules/api-requests/tee-time/types';

interface IDailyDeal {
  teeTimes: ITableTeeTime[];
  rateList: IRate[];
}

export const DailyDeal = ({ rateList, teeTimes = [] }: IDailyDeal) => {

  return (
    <DailyDealWrapper>
      <DailyDealLogoWrapper>
        <DailyDealIcon />
        <DailyDealTitle>Daily Deal</DailyDealTitle>
      </DailyDealLogoWrapper>

      {teeTimes.map((item) => (
        <a
          href={PathCreator[RoutePaths.BOOKING_DETAILS].getUrl({
            date: item.date,
            time: item.startTime,
            rate: rateList.find(rate => rate.id === item?.tradeRound?.rateId)?.id,
            offer: 'discount'
          })}
          key={item.id}
        >
          <DailyDealItem>
            <DailyDealPrice>{renderMoney(item.tradeRound?.price ?? 0)}</DailyDealPrice>
            <DailyDealDetails>
              <span>
                <ClockIcon /> {moment(item.startTime, ServerTimeFormat).format(TimeFormat)}
              </span>
              <span>
                <GroupIcon /> {renderPlayersCount(item.tradeRound?.amountPlayers ?? 1)} players
              </span>
            </DailyDealDetails>
          </DailyDealItem>
        </a>
      ))}
    </DailyDealWrapper>
  );
};
